export default __webpack_public_path__ + "static/media/line-chart-icon.6458e697.png";